import { EntityBatchNode, type EntityBatchNodeProps } from "./EntityBatchNode";

export function JobRecordBatchNode(props: Omit<EntityBatchNodeProps, "fallbackLabel">) {
  return <EntityBatchNode {...props} fallbackLabel="Job Record Batch" />;
}
